"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dragonEgg = {
    name: "dragon",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["d", "r", "a", "g", "o", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/rTwSMR4.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "350px";
        img.style.height = "350px";
        img.style.transition = "8s all linear";
        img.style.position = "fixed";
        img.style.left = "-400px";
        img.style.bottom = "calc(-50% + 320px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 8100);
    },
};
exports.default = dragonEgg;
